import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: 'Parth', // e.g: 'Name | Developer'
  lang: 'en', // e.g: en, es, fr, jp
  description: 'Welcome to my website', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: 'Hello, my name is',
  name: 'Parth S Roy',
  subtitle: 'I am a Web and App Developer',
  cta: 'Know more',
};

// ABOUT DATA
export const aboutData = {
  img: 'pic.jpg',
  paragraphOne: '4th Year UG pursuing Integrated Masters from IIT Kharagpur. Dynamic leader & motivating team player with a knack for real-life problem solving & number crunching. I love playing with software and use technology to create value for all. I enjoy learning new things and strongly believe that continuous education is the only way for all of us to evolve. I have a firm knowledge of C, C++, Python, Java and experience with web development technologies such as HTML, CSS, and JavaScript. My fields of interest are  Machine Learning, Android Development, Web Development. New challenges excites me to ponder upon using my analytical skills and problem solving abilities. ',
  // paragraphTwo: '',
  // paragraphThree: '',
  resume: 'https://drive.google.com/file/d/19uMY0CsmvH7yjnhcnpXwPAf4lkkZRs_E/view?usp=sharing', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'project.jpg',
    title: 'NETFLIX CLONE',
    info: 'This is a Netflix Clone made with React.JS and deployed in firebase.The TMDb API is used here and Youtube API is used to play the movie trailers',
    info2: '',
    url: 'https://netflix-clone-116a3.firebaseapp.com/',
    repo: 'https://github.com/psarathi012/netflix-clone', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'p.jpg',
    title: 'COVID TRACKER',
    info: 'This is project to show the COVID-19 across all the countries, libraries like chart.js, leaflet have been use.Data is fetched by API calls and then is being populated in the front-end',
    info2: '',
    url: 'https://covid-19-tracker-1ae3f.firebaseapp.com/',
    repo: 'https://github.com/psarathi012/COVID-tracker-React', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'weather.png',
    title: 'Weather App',
    info: 'It is a React App to show the weather forecast of cities around the world',
    info2: '',
    url: 'https://friendly-torvalds-2f1947.netlify.app/',
    repo: 'https://github.com/psarathi012/weather_again', // if no repo, the button will not show up
  },
];

// CONTACT DATA
export const contactData = {
  cta: '',
  btn: '',
  email: 'psarathi012@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    // {
    //   id: nanoid(),
    //   name: 'twitter',
    //   url: '',
    // },
    // {
    //   id: nanoid(),
    //   name: 'codepen',
    //   url: '',
    // },
    {
      id: nanoid(),
      name: 'linkedin',
      url: 'www.linkedin.com/in/parth-r-8662ba111',
    },
    {
      id: nanoid(),
      name: 'github',
      url: 'https://github.com/psarathi012',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: false, // set to false to disable the GitHub stars/fork buttons
};
